import { prop, required } from '@rxweb/reactive-form-validators';

export class GroupModel {
	@required()
	name: string;

	@prop({name: 'active'})
    active: string;

	@prop({name: 'number_layouts'})
    number_layouts: number;

	@prop({name: 'layout_one'})
    layout_one: any;

	@prop({name: 'layout_two'})
    layout_two: any;

	@prop({name: 'client_id'})
    client_id: any;

}
